import { getResource } from '@/shared/constants/resources'
import { confirm } from '@/shared/ui/dialog'

export const CHECKIN_REQUIRED_REASON = 'checkin_required'

type CheckinPartner = {
  id?: number | string
  uid?: string
  slug?: string
  name?: string
} | null | undefined

/**
 * Regressão: tocar num item barrado por `checkin_required` abria a folha de
 * resgate normal, com o motivo só como texto inerte no rodapé — sem dizer
 * qual parceiro nem levar até ele. O popup de bloqueio das outras condições
 * (`useBlocker`) não serve porque fala de trilha/missão/nível, não de estande.
 */
export const showCheckinRequiredAlert = async (
  partner: CheckinPartner,
  navigateTo: (path: string) => void
): Promise<void> => {
  if (!partner) return

  const partnerResource = getResource('partner')
  const path = partnerResource.getResourcePath({ resource: partner })

  const confirmed = await confirm({
    variant: 'info',
    title: 'Check-in necessário',
    description: partner.name
      ? `Para resgatar este item, passe pelo estande de ${partner.name} e faça o check-in.`
      : 'Para resgatar este item, passe pelo estande do parceiro e faça o check-in.',
    confirmLabel: 'Ir para o parceiro',
    cancelLabel: 'Ver depois'
  })

  if (confirmed) navigateTo(path)
}
